import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AuditPage from "@/AuditPage";
import CheckoutPage from "@/CheckoutPage";
import AdminAbStats from "@/AdminAbStats";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Load favicon globally for all routes
const faviconEl = document.getElementById('dynamic-favicon');
if (faviconEl) {
  faviconEl.href = `${process.env.REACT_APP_BACKEND_URL}/api/favicon?t=${Date.now()}`;
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/admin/ab-stats" element={<AdminAbStats />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
